import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Appfooter from '../components/Appfooter';
import { Link } from 'react-router-dom';
import { getFollowers } from '../services/user';

const MyFollowers = () => {
  const [followers, setFollowers] = useState<any[]>([]);

  useEffect(() => {
    const loadFollowers = async () => {
      try {
        await getFollowers();
        setFollowers([]);
      } catch (error) {
        console.log(error);
      }
    };

    loadFollowers();
  }, []);

  return (
    <>
      <Header />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left pe-0">
            <div className="row">
              <div className="col-xl-12">
                <div className="card-body p-4 w-100 bg-white border-0 d-flex rounded-3">
                  <Link to="/myprofile" className="d-inline-block mt-2">
                    <i className="ti-arrow-left font-sm text-black"></i>
                  </Link>
                  <h4 className="font-xs text-black fw-600 ms-4 mb-0 mt-2">
                    {`My Followers (${followers.length})`}
                  </h4>
                </div>
                <div className="row ps-2 pe-2">
                  {followers.length ? (
                    followers.map((value, index) => (
                      <div key={index} className="col-md-3 col-sm-4 pe-2 ps-2">
                        <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-3">
                          <div className="card-body d-block w-100 ps-3 pe-3 pb-4 text-center">
                            <figure 
                              className="overflow-hidden avatar ms-auto me-auto mb-0 position-relative z-index-1"
                              style={{ width: '65px', height: '65px' }}
                            >
                              <img
                                src={`assets/images/${value.imageUrl}`}
                                alt="avater"
                                className="float-right p-0 bg-white rounded-circle w-100 h-100 shadow-xss"
                                style={{ objectFit: 'cover' }}
                              />
                            </figure>
                            <div className="clearfix w-100"></div>
                            <h4 className="fw-700 font-xsss mt-3 mb-0">
                              {value.name}{' '}
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="align-self-center d-flex flex-column justify-content-center align-items-center p-5">
                      <i className="feather-book display5-size text-grey-400"></i>
                      <span className='text-grey-500 m-2 font-md'>No followers yet</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </>
  );
};

export default MyFollowers;
